$ = jQuery = require( 'jquery' );
require( './lib/jquery.raty' );
require( './jquery.autoKana' );

//住所周りの処理
require( './form/base' );
require( './form/area' );
require( './form/validation' );

require( './articles/article' );
require( './articles/base' );


//////////////////
// WEBPACK FOOTER
// ./app/assets/javascripts/article.js
// module id = 0
// module chunks = 0